import { render, staticRenderFns } from "./AssetNotes.vue?vue&type=template&id=e72ddd48&scoped=true&"
import script from "./AssetNotes.vue?vue&type=script&lang=js&"
export * from "./AssetNotes.vue?vue&type=script&lang=js&"
import style0 from "./AssetNotes.vue?vue&type=style&index=0&id=e72ddd48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72ddd48",
  null
  
)

export default component.exports